<template>
  <a-modal
    class="myModal smallDialog editCollectionDialog"
    :visible="visible"
    :confirmLoading='confirmLoading'
    :title="title"
    v-drag-modal
    :destroyOnClose="true"
    :width="400"
    @cancel="handleCancel">

    <template slot='footer'>
      <div class="btnsClass">
        <a-button type="link" @click="handleCancel" class="cancelBtn">取消</a-button>
        <a-button type="link" @click="handleOk" class="confirmBtn">确定</a-button>
      </div>
    </template>

    <a-divider class="divider"></a-divider>

    <a-form-model v-if="tabKey == 2" ref="form" :model='formModel' :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="名称" required prop='dataContent.name'>
        <a-input v-model="formModel.dataContent.name"></a-input>
      </a-form-model-item>
      <a-form-model-item label="颜色">
        <colorPicker v-model="formModel.dataContent.style.color" />
      </a-form-model-item>
      <a-form-model-item label="透明度" >
        <a-slider v-model="formModel.dataContent.style.opacity" :min='0' :max='1' :step="0.01"/>
      </a-form-model-item>
      <a-form-model-item label="边线颜色">
        <colorPicker v-model="formModel.dataContent.style.outlineColor" />
      </a-form-model-item>
      <a-form-model-item label="边线透明度">
        <a-slider v-model="formModel.dataContent.style.outlineOpacity" :min='0' :max='1' :step="0.01" />
      </a-form-model-item>
      <a-form-model-item label="边线宽度" >
        <a-slider v-model="formModel.dataContent.style.outlineWidth" :min='0' :max='20' :step="1"/>
      </a-form-model-item>
    </a-form-model>

    <a-form-model v-if="tabKey == 3" ref="form" :model='formModel' :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="名称" required prop='dataName'>
        <a-input v-model="formModel.dataName"></a-input>
      </a-form-model-item>
    </a-form-model>

    <a-divider class="divider"></a-divider>

  </a-modal>
</template>

<script>
// import { postHeadersAction_ds } from '../../../../api/manage'
  export default {
    name:'editCollectionDialog',
    data() {
      return {
        title:'修改标注',
        visible: false,
        confirmLoading: false,
        formModel:{
          dataName:null,
          dataContent:{
            name:'',
            style:{
              color:null,
              opacity:null,
              outlineColor:null,
              outlineOpacity:null,
              outlineWidth:null,
            }
          }
        },
        labelCol: { span: 7 },
        wrapperCol: { span: 16 },
        disabled:false,
        tabKey:null
      }
    },
    // mounted () {
    //   this.$bus.$on('closeEditDataDialog',() => {
    //     this.handleCancel()
    //   });
    // },
    // beforeDestroy () {
    //   this.$bus.$off('closeEditDataDialog');
    // },
    methods: {
      // 打开弹框页面
      openDialog(node,tabKey){
        this.tabKey = tabKey
        // console.log('编辑文件',node);
        if(tabKey == 2){
          // 编辑临时图斑的文件
          var dataContent = JSON.parse(node.dataContent)
          var style = dataContent.style ? dataContent.style : {}
          style.color = style.color ? style.color : '#c1e8f5'
          style.opacity = style.opacity ? style.opacity : 1
          style.outlineColor = style.outlineColor ? style.outlineColor : '#5bc7ec'
          style.outlineOpacity = style.outlineOpacity ? style.outlineOpacity : 0.6
          style.outlineWidth = style.outlineWidth ? style.outlineWidth : 1
          this.formModel.dataContent = dataContent
        }else{
          // 编辑分析结果的文件
          this.formModel.dataContent = node.dataContent
        }
        this.formModel.bsm = node.bsm
        this.formModel.createBy = node.createBy
        this.formModel.createTime = node.createTime
        this.formModel.dataFrom = node.dataFrom
        this.formModel.dataName = node.dataName
        this.formModel.dirBsm = node.dirBsm
        this.formModel.tenantId = node.tenantId
        this.formModel.uname = node.uname
        this.formModel.updateBy = node.updateBy
        this.formModel.updateTime = node.updateTime
        this.formModel.wjtpye = node.wjtpye
        this.visible = true
        this.$bus.$on('closeEditDataDialog',() => {
          this.handleCancel()
        });
      },
      /**
       * 点击确认
       */
      handleOk() {
        this.$refs.form.validate(valid => {
          if(valid){
            var params = JSON.parse(JSON.stringify(this.formModel))
            if(this.tabKey == 2){
              params.dataName = params.dataContent.name
              params.dataContent = JSON.stringify(params.dataContent)
            }
            this.$emit('myCollectionHandleNode','编辑数据',params)
          }
        })
      },
      /**
       * 关闭弹框
       */
      handleCancel () {
        this.$bus.$off('closeEditDataDialog');
        this.visible = false
      }
    },
  }
</script>

<style lang="less" scoped>
.btnsClass{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
  .cancelBtn {
    color: rgba(255, 255, 255, 0.50);
  }
}
/deep/ .ant-modal-footer, /deep/ .ant-modal-body, /deep/ .ant-modal-header {
  border: 0 !important;
  background: transparent !important;
}
/deep/ .ant-modal-header {
  padding: 9px 13px;
}
/deep/ .ant-modal-body {
  padding: 0;
}
/deep/ .ant-modal-footer {
  padding: 3px 0;
}
/deep/ .ant-form-item {
  display: flex;
  margin-bottom: 5px;
}
/deep/ .ant-divider-horizontal {
    min-width: 94%;
    width: 94%;
    margin: auto !important;
}
.fileDialog /deep/ .ant-modal-title {
  font-size:16px
}
/deep/ .ant-modal-close-x {
  height: 40px;
  line-height: 40px;
  i {
    color: rgba(225,225,225,0.8);
  }
}
/deep/ .ant-form-horizontal {
  margin: 12px 0;
}
/deep/ .ant-input {
  border: 1px solid rgba(255, 255, 255, 0.50);
  background: 1px solid rgba(255, 255, 255, 0.10);
}
/deep/ .colorBtn {
  width:100px !important
}
</style>